import {
  GET_OUTAGE_CONSOLIDATED_LOB,
  GET_OUTAGE_CONSOLIDATED_LOB_SUCCESS,
  GET_OUTAGE_CONSOLIDATED_LOB_FAILURE,
} from '../actions/consolidatedOutage';

const INITIAL_STATE = { loading: true, requested: false };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_OUTAGE_CONSOLIDATED_LOB:
      return {
        ...state,
        loading: true,
        error: false,
        requested: true,
      };
    case GET_OUTAGE_CONSOLIDATED_LOB_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        requested: true,
        data: action.payload,
      };
    case GET_OUTAGE_CONSOLIDATED_LOB_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        requested: true,
      };
    default:
      return state;
  }
}
